import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export const ClientsSection = () => {
  const { language } = useLanguage();

  const clients = [
    {
      name: 'Colombia U-17 FIFA Team',
      logo: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/3em7jriw_u-17%20foot%20team%20colombia%20FIFA.png',
      description: 'FIFA U-17 World Cup 2017'
    },
    {
      name: 'Toastmasters International',
      logo: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/fwsdqzsl_Toast%20masters%20logo.jpg',
      description: 'International Members'
    },
    {
      name: 'US Air Force',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Seal_of_the_United_States_Department_of_the_Air_Force.svg/1200px-Seal_of_the_United_States_Department_of_the_Air_Force.svg.png',
      description: 'Personnel Travel Services'
    },
    {
      name: 'Embassy of Rwanda',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Coat_of_arms_of_Rwanda.svg/1200px-Coat_of_arms_of_Rwanda.svg.png',
      description: 'Diplomatic Services'
    },
    {
      name: 'Eurodata Sport',
      logo: 'https://customer-assets.emergentagent.com/job_wanderlust-elite/artifacts/50onq578_Eurodata%20sport%20logo.jpg',
      description: 'London, UK'
    },
    {
      name: 'Travel Influencers',
      logo: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=200&h=200&fit=crop&q=85',
      description: 'YouTubers & Content Creators'
    }
  ];

  return (
    <section className="py-20 bg-[#FAF9F7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl text-[#2C2C2C] mb-4">
            {language === 'en' ? 'Trusted By' : 'Confiado Por'}
          </h2>
          <p className="text-lg text-[#8B7D6B] max-w-2xl mx-auto">
            {language === 'en' 
              ? 'Proudly serving international delegations, embassies, and distinguished travelers'
              : 'Sirviendo con orgullo a delegaciones internacionales, embajadas y viajeros distinguidos'}
          </p>
        </div>

        {/* Clients Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {clients.map((client, index) => (
            <div
              key={index}
              className="group flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-full h-24 flex items-center justify-center mb-3">
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-w-full max-h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                />
              </div>
              <p className="text-xs text-center text-[#8B7D6B] font-medium">
                {client.name}
              </p>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <p className="font-serif text-4xl md:text-5xl text-[#6B4E37] mb-2">500+</p>
            <p className="text-sm text-[#8B7D6B]">
              {language === 'en' ? 'Happy Travelers' : 'Viajeros Felices'}
            </p>
          </div>
          <div className="text-center">
            <p className="font-serif text-4xl md:text-5xl text-[#6B4E37] mb-2">50+</p>
            <p className="text-sm text-[#8B7D6B]">
              {language === 'en' ? 'Countries Served' : 'Países Atendidos'}
            </p>
          </div>
          <div className="text-center">
            <p className="font-serif text-4xl md:text-5xl text-[#6B4E37] mb-2">10+</p>
            <p className="text-sm text-[#8B7D6B]">
              {language === 'en' ? 'Years Experience' : 'Años de Experiencia'}
            </p>
          </div>
          <div className="text-center">
            <p className="font-serif text-4xl md:text-5xl text-[#6B4E37] mb-2">100%</p>
            <p className="text-sm text-[#8B7D6B]">
              {language === 'en' ? 'Satisfaction Rate' : 'Tasa de Satisfacción'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
